module.exports = __webpack_public_path__ + "img/somos_ricos.edda4288.jpg";